/* eslint-disable max-len */
/* Note: this file is generated by "npm run template", please dont modify this file directly */
/* -- instead, you should modify "static-files/gant-legacy/.prettierignore" and run "npm run template" */
import { ResultFile } from "@gant-lowcode/lowcode-types";

export default function getFile(): [string[], ResultFile] {
  return [
    ["."],
    {
      name: ".prettierignore",
      ext: "",
      content:
        "**/*.md\n**/*.svg\n**/*.ejs\n**/*.html\npackage.json\n.umi\n.umi-production\n.umi-test\n",
    },
  ];
}
